import { Box, useMediaQuery } from '@mui/material';
import { useState } from 'react';
// import UserHeader from './components/UserHeader';
import UserHeader from '@common/pages/Dashboard/components/UserHeader';
// import Sidebar from './components/Sidebar';
import Sidebar from '@common/components/custom/Sidebar/Sidebar';
import { sidebarWidthInPx } from '@common/utils/constants/sidebar';
import { SidebarOptions } from 'src/utils/constants/sidebar';

const DashboardMainContainer = ({ children, userRoleLabel = '' }) => {
  const isTablet = useMediaQuery('(max-width:900px)');
  const isLaptop = useMediaQuery('(max-width: 1200px)');
  const [drawerOpen, setDrawerOpen] = useState(false);

  const handleDrawerToggle = () => {
    setDrawerOpen(!drawerOpen);
  };

  // Calculate sidebar width for desktop
  // const sidebarWidth = isTablet ? 0 : isLaptop ? 250 : 280;
  const sidebarWidth = sidebarWidthInPx;

  return (
    <Box
      sx={{
        width: `100%`,
        display: 'flex',
        flexDirection: 'row',
        background: '#EBEBEB',
        minHeight: '100vh',
      }}
    >
      <Sidebar onDrawerToggle={handleDrawerToggle} drawerOpen={drawerOpen} sidebarOptions={SidebarOptions} />

      {/* Main content area */}
      <Box
        sx={{
          flexGrow: 1,
          display: 'flex',
          flexDirection: 'column',
          // marginLeft: isTablet ? 0 : `${sidebarWidth}px`,
          width: isTablet ? '100%' : `calc(100% - ${sidebarWidth}px)`,
          transition: 'margin-left 0.3s ease',
        }}
      >
        <UserHeader onMenuClick={handleDrawerToggle} showMenuButton={isTablet} userRole={userRoleLabel} />
        <Box sx={{ p: '0 16px 16px 16px', flexGrow: 1 }}>{children}</Box>
      </Box>
    </Box>
  );
};

export default DashboardMainContainer;
